const EVENT_META = {
  created: {
    icon: "ri-user-add-line",
    label: "Created",
    tone: "primary",
  },
  resume: {
    icon: "ri-file-user-line",
    label: "Resume",
    tone: "success",
  },
  status: {
    icon: "ri-flag-line",
    label: "Status",
    tone: "info",
  },
  interview: {
    icon: "ri-calendar-event-line",
    label: "Interview",
    tone: "warning",
  },
  onboard: {
    icon: "ri-user-follow-line",
    label: "Onboard",
    tone: "success",
  },
  offboard: {
    icon: "ri-user-unfollow-line",
    label: "Offboard",
    tone: "danger",
  },
};

export function getTimelineEventMeta(type) {
  return (
    EVENT_META[type] || {
      icon: "ri-record-circle-line",
      label: "Event",
      tone: "secondary",
    }
  );
}

export function formatTimelineDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function buildTimelineLink(event) {
  if (!event?.link_route || !event?.link_id) {
    if (event?.link_route === "resumes") {
      return "/resumes";
    }
    return "";
  }

  return `/${event.link_route}/${event.link_id}/view`;
}
